import React, { useState, useEffect } from "react";
import {
  useGetSellerAddressInfoQuery,
  usePostAddressSellandBuyMutation,
  usePatchAddressMutation,
  usePostAddressMutation,
  useUploadProcMediaMutation,
} from "./ProcurementApiSlice";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Button,
  Paper,
  Grid,
  Typography,
  CircularProgress,
  IconButton,
  Divider,
  TextField,
} from "@mui/material";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { Button as AntButton } from "antd";
import { Card, CardBody, Col, Row } from "reactstrap";
import CloudUploadIcon from "@mui/icons-material/CloudUpload"; // Optional, if you want an icon
import {Spinner } from "react-bootstrap"
export const AddAddressProcurement = ({
  stockId,
  setStockId,
  UserData,
  setActiveStep,
  refetch,
  setActiveCard,
  allowingEditing,
  stockQuantity,
  RolesFromToken,setAddStock,setActiveTabProject
}) => {
  const {
    data: getAddress,
    refetch: refetchAddress,
  } = useGetSellerAddressInfoQuery(stockId);
  const [postAddressSeller] = usePostAddressSellandBuyMutation();
  const [patchAddressSeller] = usePatchAddressMutation();
  const [PostAddress] = usePostAddressMutation();
  const [uploadProcMedia] = useUploadProcMediaMutation();

  const [addresses, setAddresses] = useState([
    {
      pincode: "",
      state: "",
      district: "",
      address: "",
      warehouse_name: "",
      quantity: "",
      images: [],
      videos: [],
    },
  ]);
  const [PincodeValue, setPincodeValue] = useState("");
  const [PincodeDataList, setPincodeDataList] = useState({
    State: "",
    District: "",
    Block: "",
  });
  const [pincodeError, setPinCodeError] = useState(false);

  const [editData, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showNewAddress, setNewAddress] = useState(false);
  const [addressesDetails, setAddressesDetails] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [imageList, setImageList] = useState([]);
  useEffect(() => {
    if (getAddress) {
      setAddresses(getAddress?.data);
    }
  }, [getAddress]);

  const inputStyle = (editable) => ({
    marginLeft: 8,
    border: "none",
    borderBottom: editable ? "1px solid #ccc" : "none",
    padding: "4px 8px",
    width: "100%",
    backgroundColor: editable ? "white" : "#f0f0f0",
    color: editable ? "black" : "#888",
    pointerEvents: editable ? "auto" : "none",
  });

  // const handleAddressChange = (fieldName, event) => {
  //   const { value, files } = event.target;
   
  //   const updatedAddressDetails = { ...addressesDetails };
  //   if (files) {
  //     updatedAddressDetails[fieldName] = Array.from(files);
  //     setImageList(Array.from(files));
  //   } else {
  //     updatedAddressDetails[fieldName] = value; 
  //   }
  //   if (fieldName === "pincode") {
  //     setPincodeValue(value);
  //   }
  //   setAddressesDetails(updatedAddressDetails);
  // };
  const handleAddressChange = (fieldName, event) => {
    const { value, files } = event.target;
  
    const updatedAddressDetails = { ...addressesDetails };
  
    if (files) {
      const existingFiles = updatedAddressDetails[fieldName] || [];
      const newFiles = Array.from(files);
  
      updatedAddressDetails[fieldName] = [...existingFiles, ...newFiles];
      setImageList(updatedAddressDetails[fieldName]); // Update image list state
    } else {
      updatedAddressDetails[fieldName] = value;
    }
  
    if (fieldName === "pincode") {
      setPincodeValue(value);
    }
  
    // Update the address details state
    setAddressesDetails(updatedAddressDetails);
  };
  

  const handleAddAddress = () => {
    setNewAddress(true);
    // setAddresses([
    //   ...addresses,
    //   {
    //     pincode: "",
    //     state: "",
    //     district: "",
    //     address: "",
    //     warehouse_name: "",
    //     quantity: "",
    //     images: [],
    //     videos: [],
    //   },
    // ]);
  };
  useEffect(() => {
    if (PincodeValue.length === 6) {
      const apiUrl = `https://api.postalpincode.in/pincode/${PincodeValue}`;
      fetch(apiUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data[0].Status === "Success") {
            const { State, District } = data[0].PostOffice[0];
            let updatedAddresses = { ...addressesDetails };
            updatedAddresses = {
              ...updatedAddresses,
              state: State,
              district: District,
            };
            setAddressesDetails(updatedAddresses);

            setPincodeDataList({ State, District });
            setPinCodeError(false);
          } else {
            setPinCodeError(true);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [PincodeValue]);

  const handleSubmit = () => {
    const data = {
      address_line1: addressesDetails.address,
      address_line2: "",
      city: addressesDetails?.district,
      state: addressesDetails?.state,
      country: "India",
      pincode: addressesDetails.pincode,
      email_id: "",
      phone: "",
      fax: "",
      gstin: "",
      gst_state: "",
      links: [
        {
          link_doctype: "Supplier",
          link_name: UserData,
        },
      ],
    };

    postAddressSeller(data)
      .unwrap()
      .then((response) => {
        const erpReference = response.data.name;
        const payload = {
          stock: stockId,
          quantity: addressesDetails.quantity,
          address: addressesDetails.address,
          state: addressesDetails.state,
          district: addressesDetails.district,
          pincode: addressesDetails.pincode,
          erp_address_reference: erpReference,
          warehouse_name: addressesDetails.warehouse_name,
        };

        let addressId = addressesDetails.id;

        const addressAction =
          editIndex !== null && getAddress?.data[editIndex]
            ? patchAddressSeller({ payload, addressId }).unwrap()
            : PostAddress(payload).unwrap();

        return addressAction;
      })
      .then((data) => {
        if (addressesDetails.files && addressesDetails.files.length > 0) {
          const formData = new FormData();
          formData.append("entity_type", "Seller");
          formData.append("user_id", RolesFromToken.organization_id);
          formData.append("category", "StockLocation");
          formData.append("pattern", 1);
          formData.append("stocklocation", data.data.id);

          // const files = address?.images;
          // console.log("files",files)
          // for (let i = 0; i < files.length; i++) {
          //   formData.append("files", files[i]);
          // }
          for (let i = 0; i < addressesDetails.files.length; i++) {
            formData.append("files", addressesDetails.files[i]); // Attach files
          }

          uploadProcMedia(formData)
            .unwrap()
            .then(() => {
              console.log("abc")
              // Swal.fire({
              //   title: "Images uploaded successfully!",
              //   icon: "success",
              //   confirmButtonText: "Continue",
              // }).then((result) => {
              //   if (result.isConfirmed) {
              //     setActiveCard("Seller Initiated Trade");
              //   }
              // });
            })
            .catch((error) => {
              console.error("File upload failed:", error);
              Swal.fire({
                title: "Error uploading images !! We will get back Soon .",
                text: error.message,
                icon: "error",
              });
            });
        }

        Swal.fire({
          title: `${data.message}`,
          text: `Proceed with Trading`,
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "Continue",
          cancelButtonText: "Cancel",
          confirmButtonIcon: "fas fa-arrow-right",
        }).then((result) => {
          if (result.isConfirmed) {
            setActiveCard("Seller Initiated Trade");
            setActiveTabProject("Seller Initiated Trade")
          }
        });

        refetchAddress();
        setPincodeValue("");
        refetch();
        setEdit(false);
        setAddStock(false);

      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  };
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    await handleSubmit();
    setLoading(false);
  };
  const handleEdit = (address, index) => {
    setAddressesDetails({
      pincode: address.pincode,
      state: address.state,
      district: address.district,
      address: address.address,
      warehouse_name: address.warehouse_name,
      quantity: address.quantity,
      id: address.id,
    });
    setNewAddress(true);
    setEditIndex(index);
    setEdit(true);
  };
  return (
    <Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Typography variant="h5" color="" className="mx-2 mt-3">
          <b>Saved Locations</b>
        </Typography>
        {!showNewAddress ? (
          <Button
            variant="outlined"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleAddAddress}
            size="small"
            sx={{ marginRight: 2 }}
            className="mt-3"
          >
            Add Address
          </Button>
        ) : (
          <Button
            variant="outlined"
            color="error"
            onClick={() => setNewAddress(false)}
            size="small"
            sx={{ marginRight: 2 }}
            className="mt-3"
          >
            Cancel
          </Button>
        )}
      </Box>

      {addresses?.length > 0 && !showNewAddress ? (
        <Grid container spacing={2} className="">
          {addresses?.map((address, index) => (
            <Col lg="12" sm="12" xs="12">
              <Card
                sx={{
                  border: "1px solid #ddd", // Add a subtle border
                  borderRadius: "8px", // Rounded corners
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)", // Light shadow for depth
                  transition: "transform 0.3s ease-in-out",
                  ":hover": {
                    transform: "scale(1.05)", // Slight scaling on hover for better interaction
                    boxShadow: "0 8px 16px rgba(0,0,0,0.15)", // Stronger shadow on hover
                  },
                  padding: "16px",
                }}
              >
                <CardBody className="p-3">
                  <div style={{ color: "#666" }}>
                    <h5 className="textColorHeading">
                      <b>{address.warehouse_name}</b>
                    </h5>
                    <h6>
                      {address.state} , {address.district}{" "}
                    </h6>
                    <h6>
                      {" "}
                      {address.address} - {address.pincode}
                    </h6>
                    <h6>Qty : {address.quantity} &nbsp;{stockQuantity}</h6>
                  </div>
                  <Divider>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={(e) => handleEdit(address, index)}
                    >
                      Edit
                    </Button>
                  </Divider>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Grid>
      ) : (
        <form onSubmit={(e) => handleFormSubmit(e)}>
          <Row>
            <Col lg="12" className="mt-2">
              <TextField
                id="warehouse-name"
                label="Warehouse Name"
                name="warehouse_name"
                value={addressesDetails.warehouse_name}
                disabled={editData ? true : false}
                variant="standard"
                fullWidth
                onChange={(e) => handleAddressChange("warehouse_name", e)}
                required
              />
            </Col>
            <Col lg="5" className="mt-2">
              <TextField
                id="pincode"
                name="pincode"
                value={addressesDetails.pincode}
                disabled={editData ? true : false}
                required
                label="Pincode"
                variant="standard"
                fullWidth
                onChange={(e) => handleAddressChange("pincode", e)}
              />
            </Col>
            <Col lg="5" className="offset-lg-2 mt-2">
              <TextField
                id="state"
                name="state"
                value={addressesDetails.state}
                disabled
                label="State"
                variant="standard"
                fullWidth
                onChange={(e) => handleAddressChange("state", e)}
                required
                InputLabelProps={{ shrink: true }}
              />
            </Col>
            <Col lg="12" className="mt-2">
              <TextField
                id="district"
                name="district"
                value={addressesDetails.district}
                disabled
                label="District"
                variant="standard"
                fullWidth
                onChange={(e) => handleAddressChange("district", e)}
                InputLabelProps={{ shrink: true }}
              />
            </Col>
            <Col lg="12" className="mt-2">
              <TextField
                id="addresses"
                name="address"
                value={addressesDetails.address}
                required
                label="Address (Building, Street, Area)"
                variant="standard"
                fullWidth
                onChange={(e) => handleAddressChange("address", e)}
                disabled={editData ? true : false}
              />
            </Col>
           
            <Col lg="8" className="mt-3">
  <div className="d-flex align-items-center">
    <TextField
      id="quantity"
      name="quantity"
      value={addressesDetails.quantity}
      required
      label="Quantity"
      variant="standard"
      fullWidth
      onChange={(e) => handleAddressChange("quantity", e)}
    />
    
    <div className="ms-3 text-muted">{stockQuantity}</div>
  </div>
</Col>

            <Col lg="12" className="mt-4">
              <Button
                variant="contained"
                component="label"
                size="small"
                color="inherit"
                style={{
                  backgroundColor: "#e0e0e0",
                  color: "#555",
                  padding: "6px 12px",
                  textTransform: "none",
                  width: "100%",
                }}
                startIcon={<CloudUploadIcon />}
              >
                Upload File
                <input
                  hidden
                  type="file"
                  multiple
                  accept=".jpeg, .jpg, .png"
                  onChange={(e) => handleAddressChange("files", e)} // Use "files" as the field name
                />
              </Button>
              {imageList?.length > 0 && (
                <Box mt={2} display="flex" flexWrap="wrap">
                  {imageList?.map((image, i) => (
                    <Box key={i} sx={{ marginRight: 1 }}>
                      <img
                        src={URL.createObjectURL(image)} // Create object URL for previewing
                        alt={`Uploaded ${i}`}
                        width="50"
                        height="50"
                        style={{ objectFit: "cover", borderRadius: "8px" }}
                        className="mx-3"
                      />
                    </Box>
                  ))}
                </Box>
              )}
            </Col>

            <Divider textAlign="right" className="mt-4">
              {" "}
              <Button
                variant="contained"
                textAlign="right"
                color="success"
                size="small"
                type="submit"
              >
                Update Address &nbsp;{loading?<Spinner size="small"/>:""}
              </Button>
            </Divider>
          </Row>
        </form>
      )}
    </Box>
  );
};
